import { TextField, textFieldClasses } from "@mui/material";
import { styled } from "@mui/material/styles";

type StyledTableCellProps = {
  width?: string;
};

export const TableFieldLink = styled(TextField, {
  shouldForwardProp: (prop) => prop !== "width",
})<StyledTableCellProps>(({ width }) => ({
  backgroundColor: "rgba(249, 249, 250, 0.6)",
  [`&.${textFieldClasses.root} a`]: {
    width: width || "120px",
  },
  [`&.${textFieldClasses.root} input`]: {
    width: "0px",
  },
}));
